export const selectList = (state) => state.list.list;

export const selectLoader = (state) => state.list.loader;
